import { render } from "./BranchCard.vue?vue&type=template&id=2deba54c&scoped=true"
import script from "./BranchCard.vue?vue&type=script&lang=js"
export * from "./BranchCard.vue?vue&type=script&lang=js"

import "./BranchCard.vue?vue&type=style&index=0&id=2deba54c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deba54c"]])

export default __exports__